import { getCurrentTimezoneInfo } from '@rocco/ui/calendar/utils/timezone-helpers';

/**
 * Gets the timezone abbreviation for a given IANA timezone identifier.
 * Delegates to getCurrentTimezoneInfo from rocco (which uses SUPPORTED_TZ_NAMES)
 * to avoid duplicating timezone-to-abbreviation mappings.
 * Examples: NZDT, AEDT, PST, EST, etc.
 *
 * @param tzName - The IANA timezone identifier (e.g., 'Pacific/Auckland', 'America/New_York')
 * @param timestamp - Optional timestamp (in milliseconds) to determine DST. Defaults to current time.
 * @returns Timezone abbreviation string (e.g., 'NZDT', 'PST') or the original timezone name if parsing fails
 */
export const getTimezoneShort = (
    tzName: string,
    timestamp?: number | null,
): string => {
    try {
        const date = timestamp ? new Date(timestamp) : new Date();
        return getCurrentTimezoneInfo(tzName, date).shortName;
    } catch {
        return tzName;
    }
};
